import React, { Component } from "react";
import Section from "./section";
import cookie from "react-cookies";
import axios from "axios";
import { Redirect } from "react-router-dom";
import constants from "../../Constants";

const baseURL = constants.baseURL;

class Index3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { id: 1, idnm: "home", navheading: "Home" },
        { id: 2, idnm: "services", navheading: "Services" },
        { id: 3, idnm: "features", navheading: "Features" },
        { id: 4, idnm: "clients", navheading: "Clients" },
        { id: 6, idnm: "pricing", navheading: "Plans" },
      ],
      pos: document.documentElement.scrollTop,
      imglight: false,
      navClass: "",
      redirectToProfileCompletion: false,
      profileChecked: false,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
    this.checkProfile();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > this.state.pos) {
      this.setState({ navClass: "nav-sticky", imglight: false });
    } else {
      this.setState({ navClass: "", imglight: false });
    }
  };

  checkProfile = () => {
    // If cookie is present, trust it and skip the API round-trip.
    const ctName = cookie.load("ctName");
    if (ctName) {
      this.setState({ profileChecked: true });
      return;
    }

    // Cookie might have expired (24h maxAge) or been blocked.
    // Verify against the actual profile in the DB before redirecting.
    const sessionId = cookie.load("session-id-qt");
    if (!sessionId) {
      // Not logged in at all - let the protected section handle redirect to login.
      this.setState({ profileChecked: true });
      return;
    }

    axios
      .get(baseURL + "/customer-profile", {
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionId,
        },
      })
      .then((response) => {
        const profile = response && response.data;
        if (profile && profile.firstname) {
          // Profile is complete - restore the cookies section.js relies on.
          cookie.save("ctName", profile.firstname, {
            path: "/",
            maxAge: 86400,
            secure: true,
          });
          if (profile.customerid) {
            cookie.save("localsessionid", profile.customerid, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
          }
          if (profile.promocode) {
            cookie.save("promocode", profile.promocode, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
          }
          this.setState({ profileChecked: true });
        } else {
          this.setState({
            redirectToProfileCompletion: true,
            profileChecked: true,
          });
        }
      })
      .catch(() => {
        // On failure, fall back to the old behaviour to avoid trapping the user.
        this.setState({
          redirectToProfileCompletion: true,
          profileChecked: true,
        });
      });
  };

  render() {
    if (this.state.redirectToProfileCompletion) {
      return <Redirect to="/profile-completion" />;
    }

    return (
      <React.Fragment>
        {/* Importing section */}
        <Section />
      </React.Fragment>
    );
  }
}

export default Index3;
